import { Box, Container, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { BackspaceOutlined as BackspaceOutlinedIcon, Search as SearchIcon } from '@material-ui/icons';
import ArrowCircleUpIcon from '@material-ui/icons/ArrowUpwardOutlined';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@mui/material/Tooltip';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Select from '../../../../components/Form/Select';
import TextField from '../../../../components/Form/TextField';
import AlertDialog from '../../../../components/ui/AlertDialog';
import ButtonUI from '../../../../components/ui/ButtonUI';
import LoadingUI from '../../../../components/ui/LoadingUI';
import PageTitle from '../../../../components/ui/PageTitleUI';
import { useAuth } from '../../../../hooks/auth';
import { MvmOutgoingInvoiceRequestSearch } from '../../../../interfaces/Mvm';
import MvmApi from '../../../../services/MvmApi';
import getDefaultGridOptions, { defaultHeaderOptions } from '../../../../utils/componentUtils';
import { SELECT_ONLY_ERROR } from "../../../../utils/constants";
import utilsDate from '../../../../utils/Date';
import permissions from '../../../../utils/Permissions';
import { useStyles } from '../../../Shed/Style';

const OutgoingInvoiceRequest: React.FC = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("OutgoingInvoiceRequest");
    const history = useHistory();
    const [outgoingInvoiceRequests, setOutgoingInvoiceRequests] = useState<any>([]);
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [submitData, setSubmitData] = useState<MvmOutgoingInvoiceRequestSearch>();
    const [onlyErrorList, setOnlyErrorList] = useState<any>([])
    useEffect(() => {
        setOnlyErrorList(SELECT_ONLY_ERROR)
    }, []);


    useEffect(() => {
        setLoading(false);
    }, [history, user]);

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    //Metodos do form:
    const { handleSubmit, reset, control, getValues } = useForm<any>({
        defaultValues: {
            mvmNumber: '',
            shedId: 0,
            requestNumber: '',
            invoiceKey: '',
            invoiceNumber: '',
            initialSubmitDate: null,
            endSubmitDate: null,
            status: '',
            onlyError: '',
        }
    });

//    const onSubmit = async (data: any) => {
//        search(data);
//    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        var data = getValues();
        setSubmitData(data);
    }, [page, rowsPerPage]);

    useEffect(() => {
        if(submitData === null || submitData === undefined)
        return;
        
         var objectString = JSON.stringify(submitData);
         var object = null;

         if(objectString !== null && objectString !== undefined)
            object =  JSON.parse(objectString);


            var params: MvmOutgoingInvoiceRequestSearch = {
                plantId: +user.company.plantID,
                mvmNumber: object?.mvmNumber,
                invoiceNumber: object?.invoiceNumber,
                invoiceKey: object?.invoiceKey,
                requestNumber: object?.requestNumber,
                shedCode: object?.shedCode,
                status: object?.status?.code,
                initialSubmitDate: object?.initialSubmitDate,
                endSubmitDate: object?.endSubmitDate,
                onlyError: object?.onlyError.code,
                pageSize: rowsPerPage,
                pageIndex: page,
                sortDir: 'desc',
                sort: 'UpdatedAt'         
            }

        setLoading(true);
        MvmApi.searchOutgoingInvoice(params)
            .then(result => {
                if (result) {
                    setCount(result.totalCount)
                    setPage(result.pageIndex)
                    setOutgoingInvoiceRequests(result.items);
                }
                else {
                    setOutgoingInvoiceRequests([]);
                }
            }).catch(() => {
                setOutgoingInvoiceRequests([]);
            }).finally(() => {
                setLoading(false);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitData]);

    //function search(data: any) {
    //    setLoading(true);

    //    var params: MvmOutgoingInvoiceRequestSearch = {
    //        companyId: +user.company.companyID,
    //        plantId: +user.company.plantID,
    //        mvmNumber: data.mvmNumber,
    //        invoiceNumber: data.invoiceNumber,
    //        invoiceKey: data.invoiceKey,
    //        requestNumber: data.requestNumber,
    //        shedCode: data.shedCode,
    //        status: data.status?.code,
    //        initialSubmitDate: data.initialSubmitDate,
    //        endSubmitDate: data.endSubmitDate,
    //        pageSize: rowsPerPage,
    //        pageIndex: page   ,
    //        sortDir: 'desc',
    //        sort: 'UpdatedAt'         
    //    }


    //    MvmApi.searchOutgoingInvoice(params)
    //        .then(result => {
    //            if (result) {
    //                setCount(result.totalCount)
    //                setPage(result.pageIndex)
    //                setOutgoingInvoiceRequests(result.items);
    //            }
    //            else {
    //                setOutgoingInvoiceRequests([]);
    //            }
    //        }).catch(() => {
    //            setOutgoingInvoiceRequests([]);
    //        }).finally(() => {
    //            setLoading(false);
    //        });
    //}

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'mvmNumber',
            label: t('mvmNumber'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'shedCode',
            label: t('shed'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'requestNumber',
            label: t('requestNumber'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'invoiceNumber',
            label: t('invoiceNumber'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'sentDate',
            label: t('sentDate'),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        },
        {
            name: 'returnMessage',
            label: t('ReturnMessage'),
            options: {
                ...defaultHeaderOptions,
                sort: false
            }
        },
        {
            name: 'returnMessageDate',
            label: t('ReturnMessageDate'),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        },
        {
            name: 'status',
            label: ' ',
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {

                    let canView: boolean = true//(hasPermission(permissions.MVM.Search) || hasPermission(permissions.MVM.SuperUser));
                    let canEdit: boolean = true//(hasPermission(permissions.MVM.Search) || hasPermission(permissions.MVM.SuperUser));
                    
                    return (
                        <div style={{"float": "right"}}>
                            <Box display="flex">
                                {value === 'REN' && 
                                <a href={canEdit ? '/SubmitOutgoingInvoiceRequest/' + tableMeta.rowData[0] : "#"} style={{cursor: canEdit ? "pointer" : "default"}}>
                                    <Tooltip title={String(_t('createCorrection'))}>
                                        <IconButton disabled={!canEdit} aria-label="Edit" color="primary">
                                            <EditIcon fontSize='small'/>
                                        </IconButton>
                                    </Tooltip>
                                </a>}



                                <Tooltip title={String(_t('view'))}>
                                    <a href={canView ? '/SubmitOutgoingInvoiceRequest/' + tableMeta.rowData[0] + '/View' : "#"}>
                                        <IconButton 
                                            disabled={!canView} 
                                            aria-label="View" 
                                            color="primary" >
                                            <CheckCircleIcon fontSize="small" />                            
                                        </IconButton>
                                    </a>
                                </Tooltip>
                            </Box>
                            
                        </div>
                    );
                }
            }
        },
            {
                name: "",
                options: {
                    sort: false,
                    setCellProps: () => ({
                        align: "right",
                    }),
                    customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                        
                        var canResend = false;

                        if (outgoingInvoiceRequests[tableMeta.rowIndex].sentDate != null){
                            var data1 = new Date().getTime();
                            //var dateSplit = outgoingInvoiceRequests[tableMeta.rowIndex].returnMessageDate.split('-');
                            var data2 = new Date(outgoingInvoiceRequests[tableMeta.rowIndex].sentDate).getTime();
                            const miliseconds = data1 - data2;
                            const seconds = miliseconds / 1000;
                            const minutes = seconds / 60;
                            if (Math.abs(Math.round(minutes)) > 25 )
                                canResend = true;
                        }
                        
                        return  (outgoingInvoiceRequests[tableMeta.rowIndex].returnMessage !== 'Autorizado o uso da NF-e pela SEFAZ'  && canResend ? renderResendBTPButton(tableMeta.rowData[0]) : null)
                    }
                }
        },
    ]
    const renderResendBTPButton = (id: number) => {
        return (
            <>
                <Box display="flex">
                
                    <AlertDialog
                        dialogTitle={t("dialogResendTitle")}
                        dialogContentText={t("dialogDeleteContentText")}
                        cancelTextButton={t("cancelDeleteTextButton")}
                        confirmTextButton={t("confirmDeleteTextButton")}
                        confirmDialogFunction={() => handleResendToSAP(id)}
                        Button={
                            <Tooltip title={String("Reenviar")}>
                            <IconButton 
                            size='small' 
                            edge="end"
                            aria-label="View"
                            color="primary"
                            >
                                <ArrowCircleUpIcon fontSize='small'/>   
                            </IconButton>
                            </Tooltip>
                        }
                    />
                   
                </Box>
            </>
        );
    };

    function handleResendToSAP(id: number) {
        setLoading(true);
        MvmApi.resendToSAP(id)
            .then(result => {
            }).catch(() => {
            }).finally(() => {
                var data = getValues();
                setSubmitData(data);
                setLoading(false);
            });
        //history.push(URL_REDIRECT.duplicate + id);
    }
    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(data => {setSubmitData(data);})}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI 
                                    onClick={() => reset()} 
                                    startIcon={<BackspaceOutlinedIcon />}
                                >
                                    {_t("clean")}
                                </ButtonUI>

                                <ButtonUI 
                                    type="submit"
                                    color="primary" 
                                    disabled={!hasPermission(permissions.REPORTS.ShedMovement)} 
                                    startIcon={<SearchIcon />}
                                    >
                                        {_t("search")}
                                </ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>
                            <Grid item xs={1}>
                                <TextField 
                                    label={t("mvmNumber")} 
                                    name="mvmNumber" 
                                    control={control}
                                    type="number"
                                    onInput={(e) => {
                                        (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 9) 
                                    }}
                                    fullWidth/>                            
                            </Grid>
                            <Grid item xs={2}>
                                <TextField 
                                    label={t("requestNumber")} 
                                    name="requestNumber" 
                                    control={control}
                                    type="number"
                                    onInput={(e) => { 
                                        (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 14)
                                    }}
                                    fullWidth/>                            
                            </Grid>


                            <Grid item xs={1}>
                                <TextField 
                                    label={t("invoiceNumber")} 
                                    name="invoiceNumber" 
                                    control={control}
                                    type="number"
                                    onInput={(e) => { 
                                        (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 9)
                                    }}
                                    fullWidth/>                         
                            </Grid>
                            <Grid item xs={3}>
                                <TextField 
                                    label={t("invoiceKey")} 
                                    name="invoiceKey" 
                                    control={control}
                                    type="text"
                                    onInput={(e) => { 
                                        (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44)
                                    }}
                                    fullWidth/>                         
                            </Grid>
                            <Grid item xs={2}>
                            <Select
                                label={"Tipo de Filtro"} 
                                name={"onlyError"}
                                control={control} 
                                options={onlyErrorList}
                                
                                />
                            </Grid>
                        </Grid>
                    </form>
                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={outgoingInvoiceRequests}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(_t), 
                                        serverSide: true,
                                        pagination: true,
                                        sort: outgoingInvoiceRequests?.items ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        // onRowClick: (row, index) => {
                                        //     handleOpenPanelChange(row[0]);
                                        // },
                                        page,
                                        count,
                                        rowsPerPage,
                                        onChangePage: (pageIndex) => { setPage(pageIndex) },
                                        onChangeRowsPerPage: (rowsPerPage) => { setPage(0); setRowsPerPage(rowsPerPage) },                                        

                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )


}

export default OutgoingInvoiceRequest;